import { useEffect, useState } from "react";

// FAZ F — Arama girişleri için 200 ms gecikme. Boş değer ANINDA uygulanır
// (temizleme düğmesi / Esc gecikmeli hissettirmez).
export const useDebouncedValue = (value, delay = 200) => {
  const [deger, setDeger] = useState(value);
  useEffect(() => {
    if (!value) { setDeger(value); return; }
    const h = setTimeout(() => setDeger(value), delay);
    return () => clearTimeout(h);
  }, [value, delay]);
  return deger;
};

export default useDebouncedValue;
